import { render, staticRenderFns } from "./RecognisedOffsetDeductions.vue?vue&type=template&id=7d9cf440"
import script from "./RecognisedOffsetDeductions.vue?vue&type=script&lang=js"
export * from "./RecognisedOffsetDeductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports